export default "__VITE_ASSET__d5265c88__"